<template>
<div>
    <HeaderContent header="ตั้งค่าเว็บไซต์" :img_header="header_image" link_back="content" />
    <MenuContentSetting />
    <ContentServiceList />
</div>
</template>

<script>
import HeaderImage from '@/assets/settings.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentSetting from '@/components/menuadmin/content/contentsetting/MenuContentSetting.vue'
import ContentServiceList from '@/components/menuadmin/content/contentsetting/ContentServiceList.vue'

export default {
    name: 'contentService',
    components: {
        HeaderContent,
        MenuContentSetting,
        ContentServiceList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
